(() => {
  const setupHeaderScrollEffect = () => {
    const header = document.querySelector('#header-component');
    if (!header || header.dataset.beamboxScrollReady === 'true') return;

    // 主题编辑器重新渲染区块时先清理旧监听，避免重复执行
    window.__beamboxHeaderScrollCleanup?.();
    header.dataset.beamboxScrollReady = 'true';

    let lastScrollY = window.scrollY;
    let framePending = false;

    // 根据滚动方向控制导航显示状态，减少快速滚动时的频繁重排
    const updateHeaderVisibility = () => {
      framePending = false;

      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDelta = currentScrollY - lastScrollY;
      const drawerOpen = Boolean(header.querySelector('.menu-drawer-container[open]'));

      if (drawerOpen || currentScrollY <= 12 || scrollDelta < -2) {
        header.classList.remove('beambox-header--hidden');
        header.classList.add('beambox-header--visible');
      } else if (scrollDelta > 2) {
        header.classList.remove('beambox-header--visible');
        header.classList.add('beambox-header--hidden');
      }

      lastScrollY = currentScrollY;
    };

    const handleScroll = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateHeaderVisibility);
    };

    // 打开移动端抽屉时立即显示 Header，并在抽屉关闭后继续响应滚动方向。
    const handleDrawerToggle = (event) => {
      if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches('.menu-drawer-container')) return;
      if (event.target.open) {
        header.classList.remove('beambox-header--hidden');
        header.classList.add('beambox-header--visible');
      }
      lastScrollY = Math.max(window.scrollY, 0);
    };

    header.classList.add('beambox-header--visible');
    window.addEventListener('scroll', handleScroll, { passive: true });
    header.addEventListener('toggle', handleDrawerToggle, true);

    window.__beamboxHeaderScrollCleanup = () => {
      window.removeEventListener('scroll', handleScroll);
      header.removeEventListener('toggle', handleDrawerToggle, true);
      delete window.__beamboxHeaderScrollCleanup;
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderScrollEffect, { once: true });
  } else {
    setupHeaderScrollEffect();
  }
})();
